import { render, staticRenderFns } from "./Lgx261521089648132146.vue?vue&type=template&id=8ae5dfd6&scoped=true&"
import script from "./Lgx261521089648132146.vue?vue&type=script&lang=js&"
export * from "./Lgx261521089648132146.vue?vue&type=script&lang=js&"
import style0 from "./Lgx261521089648132146.vue?vue&type=style&index=0&id=8ae5dfd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae5dfd6",
  null
  
)

export default component.exports